export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';

export function showModal(title, message, button, onConfirm) {
	return {
		type: SHOW_MODAL,
		title,
		message,
		button,
		onConfirm
	}
}

export function hideModal() {
	return {
		type: HIDE_MODAL
	}
}


// WEBPACK FOOTER //
// ./src/actions/modal.js